module.exports = require("@magento/peregrine/lib/Apollo/policies");